import classNames from 'classnames';
import React from 'react';
import { t } from '../../../../../i18n';
import { listIcon } from '../../../../assets';
import CourseVideo from '../../../../components/course-video';
import DownloadMaterialsButton from '../download-materials-button';
import './styles.scss';

const Lesson = ({
  lesson: { title, lessonNumber, lessonVideo, description, previewImageUrl, lastWatchTimeMillis, materials },
  onToggleSidebar,
  onVideoPlaybackPositionChange,
  className,
}) => {
  return (
    <div className={classNames('courses-watch-lesson__lesson', className)}>
      <div className="courses-watch-lesson__lesson__lesson-number-header">
        <SidebarToggleIcon onPress={onToggleSidebar} />
        <p className="courses-watch-lesson__lesson__lesson-number-header__text">
          {t('DIGITAL_COURSES.WATCH.LESSON_NUMBER', { number: lessonNumber })}
        </p>
      </div>
      <h1 className="courses-watch-lesson__lesson__title">{title}</h1>
      <div className="courses-watch-lesson__lesson__video-container">
        <CourseVideo
          video={lessonVideo}
          startTimeMilliseconds={lastWatchTimeMillis}
          onPlaybackPositionChange={onVideoPlaybackPositionChange}
          poster={previewImageUrl}
        />
      </div>
      <div className="courses-watch-lesson__lesson__text-block">
        <div className="courses-watch-lesson__lesson__text-block__header">
          <h2 className="courses-watch-lesson__lesson__text-block__header__title">
            {t('DIGITAL_COURSES.WATCH.TEXT_INFORMATION')}
          </h2>
          {!!materials?.length && <DownloadMaterialsButton materials={materials} />}
        </div>
        <pre
          className="courses-watch-lesson__lesson__text-block__content"
          dangerouslySetInnerHTML={{ __html: description }}
        />
      </div>
    </div>
  );
};

export default Lesson;

const SidebarToggleIcon = ({ onPress }) => (
  <button className="courses-watch-lesson__lesson__toggle-sidebar-button" onClick={onPress}>
    <img src={listIcon} alt="Lessons list" />
  </button>
);
